'use client';
import { WHATSAPP_NUMBER } from '@/constants';
import { FC } from 'react';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useCleverTap } from '@/context/clevertapContext';
import { useUser } from '@/context/userContext';
import { cn } from '@/lib/utils';

const WhatsappFloater: FC = () => {
  const pathname = usePathname();
  const { pushEvent } = useCleverTap();
  const { userDetails } = useUser();
  const isByobPage = pathname.includes('/gifting/build-your-own-box/');

  const dataToTrack = {
    Name: userDetails?.firstname
      ? `${userDetails?.firstname} ${userDetails?.lastname}`
      : 'Guest User',
    'Mobile Number': userDetails?.mobilenumber ?? 'NA',
    Email: userDetails?.email ?? 'NA',
    From: 'Floater Icon',
    Path: pathname === '/' ? 'Home' : pathname,
    'Logged In': userDetails?.id ? 'Yes' : 'No',
  };

  function handleWhatsappClick() {
    pushEvent({
      event: 'Whatsapp Interaction',
      data: dataToTrack,
    });
    window.open(
      `https://api.whatsapp.com/send?phone=91${WHATSAPP_NUMBER}&text=Hi&utm_source=Whatsapp&utm_medium=Clevetap&utm_campaign=Whatsapp_icon_web&utm_term=030624`,
      '_blank'
    );
  }

  return (
    <button
      onClick={handleWhatsappClick}
      draggable
      className={cn(
        'fixed bottom-20 right-6.5 z-20 rounded-full drop-shadow-lg md:bottom-20 md:right-16',
        isByobPage && 'bottom-50 md:bottom-20'
      )}>
      <Image
        src='/images/global/Whatsapp_Icon.png'
        alt='Whatsapp'
        title='Whatsapp'
        height={50}
        width={50}
        priority={false}
      />
    </button>
  );
};

export default WhatsappFloater;
